import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import {
  FormInput,
  FormDateSelector,
  FormSelector,
} from "../FormElements/index";
import { Button } from "../Elements";
import AmountRange from "../AmountRange";
import { filtersSchema } from "../../../common/validators/paymentLinksFilterSchema";
import { useDispatch, useSelector } from "react-redux";
import { getLinks, clearOrderLinkListCustomer } from "../../../store/slices/linkListSlice";
import { customerSelectFrom, postMessageTypes } from "../../../constants/postMessageFileds";
import { TbDots } from "react-icons/tb";
import FormFiltersShortList from "../FormElements/FormFiltersShortList";
import FormObserver from "../FormElements/FormObserver";
import { getSendOptionById, sendOptions, sendTypeIds } from "../../../constants/options/sendOptions";
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { updateIsResetForm } from "../../../store/slices/formHelperSlice";
import { postWebViewMessage } from "../../../common/helpers/messageHelper";
import { isLogoAppProject } from "../../../common/helpers/globalHelpers";
import { getSelectedValueFromId } from "../../../common/helpers/selectBoxHelper";
import { buttonTexts } from "../../../constants/texts/buttonTexts";
import { errorMessages } from "../../../constants/messages/errorMessages";
import { FieldTooltip } from "../Elements/FieldTooltip";

const statusOptions = [
  {
    value: 0,
    label: "Tümü",
  },
  {
    value: 1,
    label: "Link İletildi",
  },
  {
    value: 2,
    label: "Link İletilemedi",
  },
  {
    value: 3,
    label: "Link Açıldı",
  },
];
const paymentStatusOptions = [
  {
    value: 0,
    label: "Tümü",
  },
  {
    value: 1,
    label: "Başarılı",
  },
  {
    value: 2,
    label: "Başarısız",
  },
  {
    value: 3,
    label: "Ödeme Bekliyor",
  },
];

const today = new Date();
const sevenDaysAgo = new Date(today);
sevenDaysAgo.setDate(today.getDate() - 7);

const forminitialValue = {
  dateRange: {
    startDate: null,
    endDate: null,
  },
  statusId: 0,
  paymentStatusId: 0,
  customerPhone: "",
  customerCode: "",
  email: "",
  sendTypeId: sendTypeIds.all,
  amountRange: {
    start: 0,
    end: 0,
  },
  bankId: 0
};

export default function Filters({ isOpen, setFiltersIsOpen }) {

  const { selectedCustomer } = useSelector((state) => state.linklist);
  const [formValues, setFormValues] = useState({ ...forminitialValue });
  const [resetRangeCounter, setResetRangeCounter] = useState(0);

  const customerCodeInputRef = useRef();
  const formRef = useRef();
  const dateRangeRef = useRef();
  const isInitialRequest = useRef(true);
  const isMountedEffect = useRef(false);

  const dispatch = useDispatch();

  const [posList, setPosList] = useState([]);
  useLayoutEffect(() => {
    selectPos();
  }, [])

  useEffect(() => {
    if (selectedCustomer.code) {
      customerCodeInputRef.current.setValue(selectedCustomer.code);
      dispatch(clearOrderLinkListCustomer());
    }
  }, [selectedCustomer]);

  useEffect(() => {
    if (!isMountedEffect.current) {
      isMountedEffect.current = true;
      selectLinkList();
    }
  }, [])


  const selectPos = async () => {
    const data = await commonNetwork.get("/virtualpos");
    var poslist = [];
    if (data.isSuccess) {
      var res = data.data.data;
      poslist.push({
        value: 0,
        label: "Tümü",
      });
      for (let i = 0; i < res.length; i++) {
        const element = res[i];
        poslist.push({
          value: element.vpid,
          label: element.vpdisplayname ? element.vpdisplayname : element.bankname,
        });
      }
      setPosList(poslist);

    } else {
      toast.error(data.errorMessage);
    }
  }

  const openCustomerForm = () => {
    var callbackParameters = {
      customerSelectFrom: customerSelectFrom.fromLinkList
    }

    var messageBody = { requestType: postMessageTypes.getCustomerInfo, requestBody: "", callbackParameters: JSON.stringify(callbackParameters) };
    postWebViewMessage(JSON.stringify(messageBody));
  }

  const onSubmit = async (values, actions) => {
    if (parseFloat(formValues.amountRange.start) > parseFloat(formValues.amountRange.end) && formValues.amountRange.end !== 0) {
      toast.error(errorMessages.lowEndAmountRange);
    } else {
      var start = values.dateRange.startDate === null ? sevenDaysAgo : values.dateRange.startDate;
      var end = values.dateRange.endDate === null ? today : values.dateRange.endDate;
      var startDate = "";
      var endDate = "";
      if (start) {
        startDate = start.getDate() + "/" + (start.getMonth() + 1) + "/" + start.getFullYear();
      }
      if (end) {
        endDate = end.getDate() + "/" + (end.getMonth() + 1) + "/" + end.getFullYear();
      }

      const parameters = {
        startDate: startDate,
        endDate: endDate,
        sendType: values.sendTypeId === null ? sendTypeIds.all : values.sendTypeId,
        linkStatus: values.statusId === null ? 0 : values.statusId,
        paymentProvider: values.bankId === null ? 0 : values.bankId,
        paymentStatus: values.paymentStatusId === null ? 0 : values.paymentStatusId,
        startAmount: values.amountRange?.start,
        endAmount: values.amountRange?.end || 0,
        customerName: values.customerName || "",
        email: values.email,
        phone: values.customerPhone?.replace("(", "")
          .replace(")", "")
          .replace(/\s+/g, ""),
        invoiceNumber: values.invoiceNumber || ""
      };

      dispatch(getLinks({ parameters }));

      if (isInitialRequest.current) {
        isInitialRequest.current = false;
      } else {
        setFiltersIsOpen(false);
      }
    }
  };

  const resetFormValues = () => {
    setFormValues({
      dateRange: {
        startDate: sevenDaysAgo,
        endDate: today,
      },
      statusId: 0,
      paymentStatusId: 0,
      customerPhone: "",
      customerCode: "",
      email: "",
      sendTypeId: sendTypeIds.all,
      amountRange: {
        start: 0,
        end: 0,
      },
      bankId: 0
    });
    submitform();
    setResetRangeCounter(resetRangeCounter + 1);
  };

  const resetDateRanges = (value) => {
    var keys = Object.keys(value);

    if (keys && keys.length > 0) {
      if (keys[0] == "dateRange") {
        dateRangeRef.current.resetForm();
      }

    }
  }

  const onUpdate = (value) => {
    setFormValues(Object.assign(formValues, value));
    resetDateRanges(value);
    submitform();
    if (value.hasOwnProperty('customerName')) {
      customerCodeInputRef.current.setValue("");
    }
  };

  const selectLinkList = () => {
    if (formRef && formRef.current) {
      formRef.current.submitForm();
    }
  }

  function submitform() {
    formRef.current.submitForm();
  }

  const fields = [
    { key: "customerName", label: "Cari Hesap Ünvan", type: "text" },
    { key: "invoiceNumber", label: "Fatura Numarası", type: "text" },
    { key: "amountRange", label: "Bakiye Aralığı", type: "object", datatype: "moneyrange" },
    { key: "dateRange", label: "Tarih Aralığı", type: "object", datatype: "daterange" },
    {
      key: "statusId",
      label: "Link Durumu",
      type: "select",
      options: statusOptions,
    },
    {
      key: "paymentStatusId",
      label: "Ödeme Durumu",
      type: "select",
      options: paymentStatusOptions,
    },
    { key: "email", label: "E-Posta Adresi", type: "text" },
    { key: "customerPhone", label: "Telefon", type: "text" },
    {
      key: "sendTypeId",
      label: "Gönderim Şekli",
      type: "select",
      options: sendOptions
    },
    {
      key: "bankId",
      label: "Ödeme Altyapısı",
      type: "select",
      options: posList
    },
  ];

  return (
    <Formik
      initialValues={formValues}
      validationSchema={filtersSchema}
      onSubmit={onSubmit}
      innerRef={formRef}
      enableReinitialize
    >
      {({
        values,
        touched,
        dirty,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        handleReset,
        setFieldValue,
        setFieldTouched,
        resetForm,
        isSubmitting,
      }) => (
        <Form>
          <FormObserver
            watch={(val) => {
              setFormValues(val);
            }}
          />
          <div className={`mt-3 mx-4 mb-3 px-4 py-2 bg-white shadow-md rounded-md ${!isOpen ? "hidden" : ""}`}>
            <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-3 xl:grid-cols-4">
              <div className="flex flex-col justify-start px-0 ">
                <div className="mt-1">
                  <FormInput
                    label="Cari Hesap Ünvan"
                    name="customerName"
                    type="text"
                    ref={customerCodeInputRef}
                    rightIcon={isLogoAppProject() &&
                      <TbDots
                        onClick={openCustomerForm}
                        className="sm:block h-6 w-6 text-black hidden cursor-pointer "
                        aria-hidden="true"
                        color="#0090FF"
                      />
                    }
                  />
                </div>
                <div className="mt-2">
                  <FormInput
                    label="E-Posta Adresi"
                    name="email"
                    type="text"
                    value={formValues.email}
                  />
                </div>
                <div className="mt-2">
                  <FormInput
                    label="Telefon"
                    name="customerPhone"
                    type="text"
                    mask="(999) 999 99 99"
                  />
                </div>
              </div>
              <div className="flex flex-col justify-start px-0">
                <div className="mt-1">
                  <FormDateSelector
                    label="Tarih Aralığı"
                    name="dateRange"
                    type="range"
                    ref={dateRangeRef}
                    value={formValues.dateRange}
                    defaultStartDate={sevenDaysAgo}
                    defaultEndDate={today}
                    labelInfoIcon={
                      <FieldTooltip title={""}
                        content={"Tek seferde en fazla 30 günlük kayıt listelenebilir."} />
                    }
                    resetRangeCounter={resetRangeCounter}
                    isLimited
                    nullable
                    showDesc
                  />
                </div>
                <div className="mt-2">
                  <AmountRange
                    label="Bakiye Aralığı"
                    name="amountRange"
                    type="text"
                    value={formValues.amountRange}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                  />
                </div>
              </div>

              <div className="flex flex-col justify-start px-0 ">
                <div className="mt-1">
                  <FormSelector
                    options={sendOptions}
                    name="sendTypeId"
                    placeholder="Tümü"
                    label="Gönderim Şekli"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.sendTypeId}
                    touched={touched.sendTypeId}
                    value={getSelectedValueFromId(values.sendTypeId, sendOptions)}

                  />
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={posList}
                    name="bankId"
                    placeholder="Tümü"
                    label="Ödeme Altyapısı"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.bankId}
                    touched={touched.bankId}
                    value={getSelectedValueFromId(values.bankId, posList)}
                  />
                </div>
              </div>
              <div className="flex flex-col justify-start px-0 ">
                <div className="mt-1">
                  <FormSelector
                    options={statusOptions}
                    name="statusId"
                    placeholder="Tümü"
                    label="Link Durumu"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.statusId}
                    touched={touched.statusId}
                    value={getSelectedValueFromId(values.statusId, statusOptions)}
                  />
                </div>
                <div className="mt-3">
                  <FormInput
                    label="Fatura Numarası"
                    name="invoiceNumber"
                    type="text"
                    value={values.invoiceNumber}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                  />
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={paymentStatusOptions}
                    name="paymentStatusId"
                    placeholder="Tümü"
                    label="Ödeme Durumu"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.paymentStatusId}
                    touched={touched.paymentStatusId}
                    values={getSelectedValueFromId(values.paymentStatusId, paymentStatusOptions)}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-2 mr-0">
              <Button
                type="button"
                color="gray"
                hover="gray"
                size="xs"
                className="mr-3"
                callback={() => resetFormValues()}
              >
                <img src="/icons/delete-blue.svg" alt="deleteFilter" />
                <span className='ml-3'>{buttonTexts.filterClear}</span>
              </Button>
              <Button type="submit" color="primary" hover="primary" size="xs">
                <img src="/icons/prepare-white.svg" alt="prepare" />
                <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
              </Button>
            </div>
          </div>

          <div
            className={`m-4 px-4 py-3 bg-white shadow-md rounded-md ${isOpen ? "hidden" : ""
              }`}
          >
            <FormFiltersShortList
              formValues={{ ...values }}
              fields={fields}
              initialValues={forminitialValue}
              callback={(val) => onUpdate(val)}
              clearFilter={() => {
                resetFormValues()
                submitform();
              }}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}
